import { gql } from '@apollo/client';

export const GET_MY_COFFEE_MATCHES = gql`
  query GetMyCoffeeMatches {
    myCoffeeMatches {
      id
      status
      matchedAt
      personAId
      personBId
      reason
      metadata
      personA {
        id
        email
        profile {
          name
          firstName
          lastName
        }
        avatar {
          fileUrl
        }
        professions {
          id
          name
        }
      }
      personB {
        id
        email
        profile {
          name
          firstName
          lastName
        }
        avatar {
          fileUrl
        }
        professions {
          id
          name
        }
      }
    }
  }
`;

export const DECLINE_COFFEE_CHAT_MATCH = gql`
  mutation DeclineCoffeeChatMatch($matchId: Float!) {
    declineCoffeeChatMatch(matchId: $matchId) {
      id
      status
      respondedAt
    }
  }
`;

export const ACCEPT_COFFEE_CHAT_MATCH = gql`
  mutation AcceptCoffeeChatMatch($matchId: Float!) {
    acceptCoffeeChatMatch(matchId: $matchId) {
      id
      status
      respondedAt
    }
  }
`;